import { valueToFormatted } from 'creditu-types/format';

export const formatValueToCurrency = (value, locale, currency = '$') => {
  const valueToFormat = value ?? 0;
  const formattedValue = valueToFormatted('currencyNumber', locale, valueToFormat);
  return `${currency} ${formattedValue}`;
};
